// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export type {
  Operation,
  OperationDisplay,
  ErrorResponse,
  ErrorDetail,
  ErrorAdditionalInfo,
  DatabaseAccountGetResults,
  DatabaseAccountGetProperties,
  IpAddressOrRange,
  ConsistencyPolicy,
  DefaultConsistencyLevel,
  Capability,
  Location,
  FailoverPolicy,
  VirtualNetworkRule,
  PrivateEndpointConnection,
  PrivateEndpointConnectionProperties,
  PrivateEndpointProperty,
  PrivateLinkServiceConnectionStateProperty,
  ConnectorOffer,
  PublicNetworkAccess,
  ApiProperties,
  ServerVersion,
  AnalyticalStorageConfiguration,
  AnalyticalStorageSchemaType,
  CreateMode,
  RestoreParameters,
  RestoreMode,
  DatabaseRestoreResource,
  GremlinDatabaseRestoreResource,
  BackupPolicy,
  BackupPolicyUnion,
  BackupPolicyType,
  BackupPolicyMigrationState,
  BackupPolicyMigrationStatus,
  PeriodicModeBackupPolicy,
  PeriodicModeProperties,
  BackupStorageRedundancy,
  ContinuousModeBackupPolicy,
  ContinuousModeProperties,
  ContinuousTier,
  CorsPolicy,
  NetworkAclBypass,
  Capacity,
  DatabaseAccountKeysMetadata,
  AccountKeyMetadata,
  MinimalTlsVersion,
  DefaultPriorityLevel,
  ManagedServiceIdentity,
  ResourceIdentityType,
  Components1Jq1T4ISchemasManagedserviceidentityPropertiesUserassignedidentitiesAdditionalproperties,
  DatabaseAccountKind,
  ProxyResource,
  Resource,
  SystemData,
  CreatedByType,
  RestoreParametersBase,
  DatabaseAccountCreateUpdateParameters,
  DatabaseAccountCreateUpdateProperties,
  ARMResourceProperties,
  DatabaseAccountUpdateParameters,
  DatabaseAccountUpdateProperties,
  FailoverPolicies,
  DatabaseAccountListKeysResult,
  DatabaseAccountListReadOnlyKeysResult,
  DatabaseAccountListConnectionStringsResult,
  DatabaseAccountConnectionString,
  Kind,
  Type,
  RegionForOnlineOffline,
  DatabaseAccountRegenerateKeyParameters,
  KeyKind,
  Metric,
  UnitType,
  MetricName,
  MetricValue,
  Usage,
  MetricDefinition,
  MetricAvailability,
  PrimaryAggregationType,
  SqlDatabaseGetResults,
  SqlDatabaseGetProperties,
  SqlDatabaseGetPropertiesResource,
  SqlDatabaseGetPropertiesOptions,
  SqlDatabaseResource,
  ResourceRestoreParameters,
  OptionsResource,
  AutoscaleSettings,
  SqlDatabaseCreateUpdateParameters,
  SqlDatabaseCreateUpdateProperties,
  CreateUpdateOptions,
  ThroughputSettingsGetResults,
  ThroughputSettingsGetProperties,
  ThroughputSettingsGetPropertiesResource,
  ThroughputSettingsResource,
  AutoscaleSettingsResource,
  AutoUpgradePolicyResource,
  ThroughputPolicyResource,
  ThroughputSettingsUpdateParameters,
  ThroughputSettingsUpdateProperties,
  CloudError,
  CosmosDBErrorResult,
  ClientEncryptionKeyGetResults,
  ClientEncryptionKeyGetProperties,
  ClientEncryptionKeyGetPropertiesResource,
  ClientEncryptionKeyResource,
  KeyWrapMetadata,
  ClientEncryptionKeyCreateUpdateParameters,
  ClientEncryptionKeyCreateUpdateProperties,
  SqlContainerGetResults,
  SqlContainerGetProperties,
  SqlContainerGetPropertiesResource,
  SqlContainerGetPropertiesOptions,
  SqlContainerResource,
  IndexingPolicy,
  IndexingMode,
  IncludedPath,
  Indexes,
  DataType,
  IndexKind,
  ExcludedPath,
  CompositePath,
  CompositePathSortOrder,
  SpatialSpec,
  SpatialType,
  VectorIndex,
  VectorIndexType,
  FullTextIndexPath,
  ContainerPartitionKey,
  PartitionKind,
  UniqueKeyPolicy,
  UniqueKey,
  ConflictResolutionPolicy,
  ConflictResolutionMode,
  ClientEncryptionPolicy,
  ClientEncryptionIncludedPath,
  ComputedProperty,
  VectorEmbeddingPolicy,
  VectorEmbedding,
  VectorDataType,
  DistanceFunction,
  FullTextPolicy,
  FullTextPath,
  SqlContainerCreateUpdateParameters,
  SqlContainerCreateUpdateProperties,
  ContinuousBackupRestoreLocation,
  BackupInformation,
  ContinuousBackupInformation,
  SqlStoredProcedureGetResults,
  SqlStoredProcedureGetProperties,
  SqlStoredProcedureGetPropertiesResource,
  SqlStoredProcedureResource,
  SqlStoredProcedureCreateUpdateParameters,
  SqlStoredProcedureCreateUpdateProperties,
  SqlUserDefinedFunctionGetResults,
  SqlUserDefinedFunctionGetProperties,
  SqlUserDefinedFunctionGetPropertiesResource,
  SqlUserDefinedFunctionResource,
  SqlUserDefinedFunctionCreateUpdateParameters,
  SqlUserDefinedFunctionCreateUpdateProperties,
  SqlTriggerGetResults,
  SqlTriggerGetProperties,
  SqlTriggerGetPropertiesResource,
  SqlTriggerResource,
  TriggerType,
  TriggerOperation,
  SqlTriggerCreateUpdateParameters,
  SqlTriggerCreateUpdateProperties,
  SqlRoleDefinitionGetResults,
  SqlRoleDefinitionResource,
  RoleDefinitionType,
  Permission,
  SqlRoleDefinitionCreateUpdateParameters,
  SqlRoleAssignmentGetResults,
  SqlRoleAssignmentResource,
  SqlRoleAssignmentCreateUpdateParameters,
  MongoDBDatabaseGetResults,
  MongoDBDatabaseGetProperties,
  MongoDBDatabaseGetPropertiesResource,
  MongoDBDatabaseGetPropertiesOptions,
  MongoDBDatabaseResource,
  MongoDBDatabaseCreateUpdateParameters,
  MongoDBDatabaseCreateUpdateProperties,
  MongoDBCollectionGetResults,
  MongoDBCollectionGetProperties,
  MongoDBCollectionGetPropertiesResource,
  MongoDBCollectionGetPropertiesOptions,
  MongoDBCollectionResource,
  MongoIndex,
  MongoIndexKeys,
  MongoIndexOptions,
  MongoDBCollectionCreateUpdateParameters,
  MongoDBCollectionCreateUpdateProperties,
  MongoRoleDefinitionGetResults,
  MongoRoleDefinitionResource,
  MongoRoleDefinitionType,
  Privilege,
  PrivilegeResource,
  Role,
  MongoRoleDefinitionCreateUpdateParameters,
  MongoUserDefinitionGetResults,
  MongoUserDefinitionResource,
  MongoUserDefinitionCreateUpdateParameters,
  TableGetResults,
  TableGetProperties,
  TableGetPropertiesResource,
  TableGetPropertiesOptions,
  TableResource,
  TableCreateUpdateParameters,
  TableCreateUpdateProperties,
  TableRoleDefinitionResource,
  TableRoleDefinitionResourceProperties,
  TableRoleAssignmentResource,
  TableRoleAssignmentResourceProperties,
  CassandraKeyspaceGetResults,
  CassandraKeyspaceGetProperties,
  CassandraKeyspaceGetPropertiesResource,
  CassandraKeyspaceGetPropertiesOptions,
  CassandraKeyspaceResource,
  CassandraKeyspaceCreateUpdateParameters,
  CassandraKeyspaceCreateUpdateProperties,
  CassandraTableGetResults,
  CassandraTableGetProperties,
  CassandraTableGetPropertiesResource,
  CassandraTableGetPropertiesOptions,
  CassandraTableResource,
  CassandraSchema,
  Column,
  CassandraPartitionKey,
  ClusterKey,
  CassandraTableCreateUpdateParameters,
  CassandraTableCreateUpdateProperties,
  CassandraRoleDefinitionResource,
  CassandraRoleDefinitionResourceProperties,
  CassandraRoleAssignmentResource,
  CassandraRoleAssignmentResourceProperties,
  GremlinDatabaseGetResults,
  GremlinDatabaseGetProperties,
  GremlinDatabaseGetPropertiesResource,
  GremlinDatabaseGetPropertiesOptions,
  GremlinDatabaseResource,
  GremlinDatabaseCreateUpdateParameters,
  GremlinDatabaseCreateUpdateProperties,
  GremlinGraphGetResults,
  GremlinGraphGetProperties,
  GremlinGraphGetPropertiesResource,
  GremlinGraphGetPropertiesOptions,
  GremlinGraphResource,
  GremlinGraphCreateUpdateParameters,
  GremlinGraphCreateUpdateProperties,
  GremlinRoleDefinitionResource,
  GremlinRoleDefinitionResourceProperties,
  GremlinRoleAssignmentResource,
  GremlinRoleAssignmentResourceProperties,
  NotebookWorkspace,
  NotebookWorkspaceProperties,
  NotebookWorkspaceName,
  NotebookWorkspaceCreateUpdateParameters,
  ARMProxyResource,
  NotebookWorkspaceConnectionInfoResult,
  PrivateLinkResource,
  PrivateLinkResourceProperties,
  PercentileMetric,
  PercentileMetricValue,
  PartitionMetric,
  PartitionUsage,
  LocationGetResult,
  LocationProperties,
  Status,
  ClusterResource,
  ClusterResourceProperties,
  ManagedCassandraProvisioningState,
  AuthenticationMethod,
  SeedNode,
  AutoReplicate,
  Certificate,
  CassandraError,
  BackupSchedule,
  ScheduledEventStrategy,
  AzureConnectionType,
  ManagedCassandraManagedServiceIdentity,
  ManagedCassandraResourceIdentityType,
  CommandPostBody,
  CommandOutput,
  CassandraClusterPublicStatus,
  ManagedCassandraReaperStatus,
  ConnectionError,
  ConnectionState,
  CassandraClusterPublicStatusDataCentersItem,
  ComponentsM9L909SchemasCassandraclusterpublicstatusPropertiesDatacentersItemsPropertiesNodesItems,
  NodeState,
  DataCenterResource,
  DataCenterResourceProperties,
  AuthenticationMethodLdapProperties,
  RestorableDatabaseAccountGetResult,
  RestorableDatabaseAccountProperties,
  ApiType,
  RestorableLocationResource,
  RestorableSqlDatabaseGetResult,
  RestorableSqlDatabaseProperties,
  RestorableSqlDatabasePropertiesResource,
  OperationType,
  RestorableSqlDatabasePropertiesResourceDatabase,
  RestorableSqlContainerGetResult,
  RestorableSqlContainerProperties,
  RestorableSqlContainerPropertiesResource,
  RestorableSqlContainerPropertiesResourceContainer,
  RestorableSqlResourcesGetResult,
  RestorableMongodbDatabaseGetResult,
  RestorableMongodbDatabaseProperties,
  RestorableMongodbDatabasePropertiesResource,
  RestorableMongodbCollectionGetResult,
  RestorableMongodbCollectionProperties,
  RestorableMongodbCollectionPropertiesResource,
  RestorableMongodbResourcesGetResult,
  RestorableGremlinDatabaseGetResult,
  RestorableGremlinDatabaseProperties,
  RestorableGremlinDatabasePropertiesResource,
  RestorableGremlinGraphGetResult,
  RestorableGremlinGraphProperties,
  RestorableGremlinGraphPropertiesResource,
  RestorableGremlinResourcesGetResult,
  RestorableTableGetResult,
  RestorableTableProperties,
  RestorableTablePropertiesResource,
  RestorableTableResourcesGetResult,
  ServiceResource,
  ServiceResourceProperties,
  ServiceResourcePropertiesUnion,
  ServiceSize,
  ServiceType,
  ServiceStatus,
  DataTransferServiceResourceProperties,
  DataTransferRegionalServiceResource,
  SqlDedicatedGatewayServiceResourceProperties,
  DedicatedGatewayType,
  SqlDedicatedGatewayRegionalServiceResource,
  GraphAPIComputeServiceResourceProperties,
  GraphAPIComputeRegionalServiceResource,
  MaterializedViewsBuilderServiceResourceProperties,
  MaterializedViewsBuilderRegionalServiceResource,
  RegionalServiceResource,
  ServiceResourceCreateUpdateParameters,
  ServiceResourceCreateUpdateProperties,
  ServiceResourceCreateUpdatePropertiesUnion,
  DataTransferServiceResourceCreateUpdateProperties,
  SqlDedicatedGatewayServiceResourceCreateUpdateProperties,
  GraphAPIComputeServiceResourceCreateUpdateProperties,
  MaterializedViewsBuilderServiceResourceCreateUpdateProperties,
  MongoMIRoleDefinitionResource,
  MongoMIRoleDefinitionResourceProperties,
  MongoMIRoleAssignmentResource,
  MongoMIRoleAssignmentResourceProperties,
  FleetResource,
  FleetResourceProperties,
  TrackedResource,
  FleetResourceUpdate,
  FleetspaceResource,
  FleetspaceProperties,
  FleetspacePropertiesFleetspaceApiKind,
  FleetspacePropertiesServiceTier,
  FleetspacePropertiesThroughputPoolConfiguration,
  FleetspaceUpdate,
  FleetspaceAccountResource,
  FleetspaceAccountProperties,
  FleetspaceAccountPropertiesGlobalDatabaseAccountProperties,
  DatabaseAccountsCheckNameExistsResponse,
} from "./models.js";
export {
  KnownConnectorOffer,
  KnownPublicNetworkAccess,
  KnownServerVersion,
  KnownAnalyticalStorageSchemaType,
  KnownCreateMode,
  KnownRestoreMode,
  KnownBackupPolicyType,
  KnownBackupPolicyMigrationStatus,
  KnownBackupStorageRedundancy,
  KnownContinuousTier,
  KnownMinimalTlsVersion,
  KnownDefaultPriorityLevel,
  KnownDatabaseAccountKind,
  KnownCreatedByType,
  KnownKind,
  KnownType,
  KnownKeyKind,
  KnownUnitType,
  KnownPrimaryAggregationType,
  KnownIndexingMode,
  KnownDataType,
  KnownIndexKind,
  KnownCompositePathSortOrder,
  KnownSpatialType,
  KnownVectorIndexType,
  KnownPartitionKind,
  KnownConflictResolutionMode,
  KnownVectorDataType,
  KnownDistanceFunction,
  KnownTriggerType,
  KnownTriggerOperation,
  KnownNotebookWorkspaceName,
  KnownStatus,
  KnownManagedCassandraProvisioningState,
  KnownAuthenticationMethod,
  KnownAutoReplicate,
  KnownScheduledEventStrategy,
  KnownAzureConnectionType,
  KnownManagedCassandraResourceIdentityType,
  KnownConnectionState,
  KnownNodeState,
  KnownApiType,
  KnownOperationType,
  KnownServiceSize,
  KnownServiceType,
  KnownServiceStatus,
  KnownDedicatedGatewayType,
  KnownFleetspacePropertiesFleetspaceApiKind,
  KnownFleetspacePropertiesServiceTier,
  KnownVersions,
} from "./models.js";
